import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyB1osKFivTPIjQrJmPrHsUKUq6rEauTr_k",
  authDomain: "smeproje.firebaseapp.com",
  projectId: "smeproje",
  storageBucket: "smeproje.appspot.com",
  messagingSenderId: "189914933296",
  appId: "1:189914933296:web:d51120eece71ce38c825f5",
  measurementId: "G-C2VG0YJWB6",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore();

export const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
